<div align="right" class="notif-dialog-icon">
  <button mat-icon-button mat-dialog-close>
        <mat-icon color="red">close</mat-icon>
      </button>
</div>
<div>
  <p [innerHTML]="notification.message"></p>
  <mat-checkbox (change)="disableNotif($event)" color="primary">
    Ne plus afficher ce message
  </mat-checkbox>
</div>